


















import { Component, Mixins } from "vue-property-decorator";
import { Plan } from "@foxone/api/src/models/hfox";
import PlanAction from "hfox/components/plan/PlanAction.vue";
import PlanInfo from "hfox/components/plan/PlanInfo.vue";
import PlanCharts from "hfox/components/plan/charts/Index.vue";
import IncomingSchedule from "hfox/components/plan/IncomingSchedule.vue";
import ScheduleList from "hfox/components/plan/schedules/ScheduleList.vue";
import { Getter } from "vuex-class";
import mixins from "@/mixins";

@Component({
  components: {
    PlanAction,
    PlanInfo,
    PlanCharts,
    IncomingSchedule,
    ScheduleList
  }
})
class PlanDetail extends Mixins(mixins.page) {
  @Getter("hfox/getPlanById") getPlanById;

  get plan(): Plan {
    return this.getPlanById(this.id);
  }

  get appbar(): any {
    return {
      title: this.$t("hfox.plan.detail")
    };
  }

  get title() {
    return this.$t("hfox.plan.detail") as string;
  }

  get id() {
    return this.$route.params.id as string;
  }

  loadPlanData() {
    this.$store.dispatch("hfox/loadPlans");
  }
}
export default PlanDetail;
